import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import toastr from 'toastr';

import {connect} from 'react-redux';
import WhitelistDomain from '../../store/services/whitelistDomain';
import FormContainer from '../form-components/FormContainer';
import {ErrorMessages} from '../form-components/ErrorMessages';
import WhitelistDomainForm from './WhitelistDomainForm';

class NewWhitelistDomainScreen extends Component {
  state = {
    loading: false,
    whitelistDomain: {
      domainName: '',
    },
    error: {},
    userError: false,
    hasUserId: false,
    user: {},
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, {name, value}) => {
    this._mutate(draft => {
      draft.whitelistDomain[name] = value;
    });
  };

  _loadWhitelistedDomains = (pageNumber, searchTerm) => {
    withLifecycles(
      () =>
        WhitelistDomain.fetch({
          request: {
            page: pageNumber,
            pageSize: 20,
          },
          searchTerm: searchTerm,
          orderByName: false,
        }),
      ({loading, data}) => {
        this.setState({activePage: pageNumber + 1});
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          }),
        );
      },
    );
  };

  _save = () => {
    withLifecycles(
      () => WhitelistDomain.whitelistDomain(this.state.whitelistDomain),
      ({loading, data, error}) => {
        this._mutate(draft => {
          draft.loading = loading;
          draft.error = error;

          if (data && !data.hasErrors) {
            this._loadWhitelistedDomains(0, '');
            toastr.success('Whitelisted Domain Created');
            this.props.history.push('/manage/whitelists/domains');
          }
        });
      },
    );
  };

  render() {
    const {error, loading, whitelistDomain} = this.state;

    return (
      <FormContainer loading={loading}>
        <Form onSubmit={this._save}>
          <WhitelistDomainForm
            whitelistDomain={whitelistDomain}
            handleTextChanged={this._handleTextChanged}
            isReadOnly={false}
            isBeingEdited={false}
          />
          <ErrorMessages error={error} />
          <Button type="submit">
            <Icon
              style={{paddingRight: '15px'}}
              name="check circle"
              color="Black"
            />
            Whitelist Domain
          </Button>
          <Button basic as={Link} to="/manage/whitelists/domains">
            Cancel
          </Button>
        </Form>
      </FormContainer>
    );
  }
}

const mapStateToProps = ({customers, identity}) => ({
  customers: customers.data,
  role: identity.user.role,
});

export default connect(mapStateToProps)(NewWhitelistDomainScreen);
